<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <div class="title">LOOTIQUE<span>skins</span></div>
        </router-link>
        <div v-if="$route.name != 'Home'" class="input-container">
          <input
            v-model="search"
            type="text"
            placeholder="Search"
            @keyup.enter="onEnter"
          />
          <img src="./../assets/glass.svg" class="img" @click="onEnter" />
        </div>
      </div>
      <div class="right">
        <div @click="sellSkin" class="nav">
          <div class="nav__item">
            <a class="desc">
              {{ $t("Sell skin") }}
            </a>
          </div>
        </div>

        <div class="nav">
          <div class="nav__item">
            <a class="desc" @click="setProductCategory('all')">
              {{ $t("Market") }}
            </a>
          </div>
        </div>
        <div
          v-if="
            curr &&
            $parent.currencyOptions &&
            $parent.currencyOptions.length > 1
          "
          class="select-container"
        >
          <Select2
            v-model="curr"
            class="select2 single currency-select"
            :placeholder="curr"
            :options="$parent.currencyOptions"
            @select="selectCurr($event)"
          />
        </div>
        <div
          v-if="currentLanguage"
          class="select-container language-select-container"
        >
          <Select2
            v-model="language"
            class="select2 single currency-select"
            :options="languages"
            :placeholder="currentLanguageName"
            @select="selectLanguage($event)"
          />
        </div>
        <div v-if="$parent.isAuth" class="cash">
          <img src="./../assets/wallet.svg" class="img" />
          <div class="desc">
            <p>{{ balance }}</p>
            <img class="img" src="./../assets/coin.png" />
            <div class="rate-desc" v-if="$parent.rate">
              {{ 1 }} {{ $parent.currency }} =
              {{ $parent.rate }}
              <img class="img" src="./../assets/coin.png" />
            </div>
          </div>
          <button class="button" @click="$parent.openTopup">
            <img src="./../assets/plus.svg" class="img" />
          </button>
        </div>
        <button
          v-if="$parent.isAuth"
          :class="[
            'button dark icon icon-cart round',
            { gray: !cartContents.length },
          ]"
          @click="$parent.openCart"
        >
          <img src="./../assets/cart.svg" class="img" />
          <div v-if="cartContents.length" class="indicator">
            {{ cartContents.length }}
          </div>
        </button>
        <router-link
          v-if="$parent.isAuth"
          to="/profile/settings"
          class="button dark link-container dropdown-open round"
        >
          <img src="./../assets/user.svg" class="img" />
        </router-link>
        <div v-else class="link-container">
          <div class="desc rate-desc" v-if="$parent.rate">
            {{ 1 }} {{ $parent.currency }} =
            {{ $parent.rate }}
            <img class="img" src="./../assets/coin.png" />
          </div>
          <div class="button transparent" @click="$parent.openSignUp">
            <span>{{ $t("Sign Up") }}</span>
          </div>
          <div class="button" @click="$parent.openSignIn">
            <span>{{ $t("Sign In") }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Select2 from "vue3-select2-component";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "Header",
  components: {
    Select2,
  },
  props: {
    cartContents: {
      type: [Array, String],
      required: true,
    },
    currencyCode: {
      type: String,
      required: true,
    },
    searchedProductText: {
      type: String,
      required: true,
    },
    isAuth: {
      type: Boolean,
      required: true,
    },
    appBalance: {
      type: [Number, String],
      required: true,
    },
  },

  data: function () {
    return {
      search: "",
      curr: "",
      balance: "0.00",
    };
  },
  computed: {
    ...mapState({
      languages: ({ app: { languages } }) =>
        languages.map(({ id, title: text }) => ({ id, text })),
      currentLanguage: (state) => state.app.currentLanguage,
    }),
    ...mapGetters("app", ["currentLanguageName"]),
    language: {
      set(langId) {
        this.changeLocale(langId);
      },
      get() {
        return this.currentLanguage;
      },
    },
  },
  watch: {
    currencyCode(newValue) {
      this.curr = newValue;
      this.getBalance();
    },
    searchedProductText: function (newVal) {
      this.search = newVal;
    },
    isAuth() {
      this.getBalance();
    },
    appBalance() {
      this.getBalance();
    },
  },
  mounted() {
    this.curr = this.currencyCode;
    this.getBalance();
  },
  methods: {
    getBalance() {
      if (this.$parent.isAuth) {
        this.$http
          .get(process.env.VUE_APP_API + "user/profile")
          .then((res) => {
            this.balance = res.data.balance;
          })
          .catch((res) => {
            if (res.response.status === 401) {
              this.$parent.openSignIn();
            }
          });
      }
    },
    sellSkin() {
      if (this.$parent.isAuth) {
        this.$parent.openSellSkinModal();
      } else {
        this.$parent.openSignIn();
      }
    },
    searchSubmit() {
      this.$emit("searchSubmit", this.search);
    },
    onEnter() {
      this.searchSubmit();
    },
    selectCurr(event) {
      this.curr = event.text;
      this.changeCurrency(event.text);
      localStorage.setItem("currency", event.text);
    },
    selectLanguage(event) {
      this.changeLocale(parseInt(event.id));
    },
    changeCurrency(item) {
      this.$emit("changeCurrency", item);
    },
    setProductCategory(category) {
      this.$emit("setProductCategory", category);
    },
    ...mapMutations("app", ["setCurrentLanguage"]),
    ...mapActions("app", ["changeLocale"]),
  },
};
</script>
